export const filter_config = (audience_options = []) => {
  return {
    title: 'Contact filters',
    filters: [
      {
        label: 'Audiences',
        key: 'subscriptions',
        value: audience_options,
        type: 'multichoice'
      },
      { value: 'created_on', label: 'Date created', key: 'created_on', type: 'range' }
    ]
  };
};
